(function () {
  /**
   * "root" is an object to hang all namespaces on. Ideally this would be isolated from the global object, but so much
   * of eSM is already global setting "root" to Window can simplify access to existing "modules" without too much
   * rewriting.
   */
  var root = window;

  // Namespace to use if none is provided.
  var DEFAULT_NAMESPACE = 'leica.pi';

  /**
   * Finds or creates a namespace and returns the final ns object.
   *   example: var utils = namespace('leica.pi.utils');
   * @param name
   * @returns {{}}
   */
  function namespace (name) {
    if (!name) {
      name = DEFAULT_NAMESPACE;
    }

    if (typeof name !== 'string') {
      throw new Error('Cannot create a namespace without a name, silly!');
    }

    var bits = name.split('.');
    var obj = root;
    var segment;
    do {
      segment = bits.shift();
      if (!obj[segment]) {
        obj[segment] = {};
      }
      obj = obj[segment];
    } while (bits.length > 0);

    return obj;
  }

  // Syntactic Sugar:
  namespace.create = namespace;
  namespace.using = namespace;

  // Make it global (as opposed to, well, namespacing it) to simplify usage.
  window.namespace = namespace;
}());
